import { useState } from 'react';
import { Space } from 'antd';
import { SolutionOutlined } from '@ant-design/icons';
import { useTranslate } from '@tolgee/react';
import { LogDrawer } from './LogDrawer';

export interface TaskOperationLogProps {
  taskId?: string;
  scenarioType: Marketing.AllScenarioType;
  round?: number;
  platform: General.PlatformUpperCase;
  region: General.UpperCaseRegion;
}

export const TaskOperationLog = (props: TaskOperationLogProps) => {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslate();

  return (
    <>
      <Space
        align="center"
        onClick={() => {
          setVisible(true);
        }}
        size={2}
        className="cursor-pointer hover:text-primary-hover"
      >
        <SolutionOutlined />
        <span>{t('aide.操作日志')}</span>
      </Space>
      <LogDrawer
        {...props}
        title={t('aide.操作日志')}
        visible={visible}
        size="large"
        onClose={() => {
          setVisible(false);
        }}
      />
    </>
  );
};
